import { isNonRecoverableError, isRecoverableError } from '@grandvisionhq/fun-products';

const getSelectors = ()=>{
    const columnsIsNonOrderable = (column)=>{
        return column.isEnabled && column.quantitySelector.maxSelectableQuantity === 0;
    };
    const hasNonOrderableProduct = (state)=>{
        /**
     * For the ContactLensesEcommState, a product is considered non orderable if they have an
     * available quantity of 0 and are not back orderable. If this is the case, the maxSelectableQuantity
     * will also be 0.
     */ return columnsIsNonOrderable(state.configurator.left) || columnsIsNonOrderable(state.configurator.right);
    };
    const hasNonrecoverableErrorOnEyeside = (state, eyeSide)=>{
        const { configurator , queries  } = state;
        return configurator[eyeSide].isEnabled && isNonRecoverableError(queries[eyeSide].error);
    };
    const hasNonrecoverableError = (state)=>{
        return hasNonrecoverableErrorOnEyeside(state, 'left') || hasNonrecoverableErrorOnEyeside(state, 'right');
    };
    const hasRecoverableErrorOnEyeside = (state, eyeSide)=>{
        const { configurator , queries  } = state;
        return configurator[eyeSide].isEnabled && isRecoverableError(queries[eyeSide].error);
    };
    const hasRecoverableError = (state)=>{
        return hasRecoverableErrorOnEyeside(state, 'left') || hasRecoverableErrorOnEyeside(state, 'right');
    };
    const hasQueryError = (state)=>{
        return hasNonrecoverableError(state) || hasRecoverableError(state);
    };
    return {
        hasNonOrderableProduct,
        hasNonrecoverableError,
        hasNonrecoverableErrorOnEyeside,
        hasRecoverableErrorOnEyeside,
        hasRecoverableError,
        hasQueryError
    };
};

export { getSelectors };
//# sourceMappingURL=selectors.js.map
